import type { FC } from 'react';
import { useCallback } from 'react';

import { TagSearchableDropdown } from '../../../../../components/tag-dropdown/tag-searchable-dropdown';

import type { TriggerFilterDraft } from '../../types.d';
import type { EventFilterInputProps } from '../../registries/registry-types.d';

const TAG_EVENT_FILTER_FIELD = 'TagId';
const TAG_EVENT_FILTER_OPERATOR = 'Equals';
const TAG_EVENT_FILTER_VALUE_TYPE = 'int';

export const TagEventFilterInput: FC<EventFilterInputProps> = ({ step, onUpdateStep }) => {
  const selectedFilter = step.eventFilters?.[0] ?? null;

  const handleSelectTag = useCallback(
    (tagId: string) => {
      if (!tagId) return;
      const newFilter: TriggerFilterDraft = {
        field: TAG_EVENT_FILTER_FIELD,
        operator: TAG_EVENT_FILTER_OPERATOR,
        value: tagId,
        valueType: TAG_EVENT_FILTER_VALUE_TYPE,
      };
      onUpdateStep({ ...step, eventFilters: [newFilter] });
    },
    [step, onUpdateStep],
  );

  return <TagSearchableDropdown onChange={handleSelectTag} value={selectedFilter?.value ?? ''} />;
};
